import { render } from "./DataDisplay.vue?vue&type=template&id=725cf26c"
import script from "./DataDisplay.vue?vue&type=script&lang=js"
export * from "./DataDisplay.vue?vue&type=script&lang=js"

import "./DataDisplay.vue?vue&type=style&index=0&id=725cf26c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__